export const CUSTOM_VALUE = 'custom';

export const OPERATOR_MAP: Record<string, string> = {
  gt: '>',
  gte: '≥',
  lt: '<',
  lte: '≤',
  eq: '=',
};
